export default __webpack_public_path__ + "static/media/success.6f8db4b5.svg";